import { ReactNode } from 'react';
import { Box, Toolbar } from '@mui/material';
import Drawer from './Drawer';
import NoInternetConnection from './NoInternetConnection';

const sidebarWidth = 285;

type AppLayoutProps = {
    children: ReactNode;
};

export const AppLayout = ({ children }: AppLayoutProps) => {
    return (
        <Box className="flex">
            <Drawer sidebarWidth={sidebarWidth} />
            <Box className="w-full">
                <Toolbar />
                {children}
                <NoInternetConnection sidebarWidth={sidebarWidth} />
            </Box>
        </Box>
    );
};
